import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'
import {documentToHtmlString} from '@contentful/rich-text-html-renderer'
import type {GenericContent, GenericCTAGroup} from '../../../../../../brand/lib/types/contentful'

import {Heading, Prose, Text} from '@primer/react-brand'
import {CtaButtons} from '../../_shared/CtaButtons/CtaButtons'
import {Label} from '../../_shared/Label/Label'
import {Spacer} from '../../_shared/Spacer/Spacer'
import {MediaAsset} from '../../_shared/MediaAsset/MediaAsset'

import Styles from './River.module.css'

type Props = {
  content: GenericContent
  index: number
  location: string
}

export function River(props: Props) {
  const {content, index, location} = props
  const {heading, subheading, label, text, ctas, media} = content.fields

  const title = heading
  const subTitle = subheading ? documentToPlainTextString(subheading) : ''

  const eyebrow = label?.fields.text
  const description = text ? documentToHtmlString(text) : ''

  const ctaGroup = ctas?.at(0) as GenericCTAGroup

  return (
    <div className={Styles.River} data-direction={index % 2 === 0 ? 'left' : 'right'}>
      <div className={Styles.Cell}>
        <div className={Styles.Content}>
          {eyebrow && (
            <>
              <Label text={eyebrow} />
              <Spacer size="64px" size1280="0" />
            </>
          )}

          {title && (
            <Heading data-heading="2" as="h2">
              {title}
            </Heading>
          )}

          <div>
            {subTitle && (
              <>
                <Spacer size="32px" size1280="0" />
                <Text className={Styles.SubTitle} weight="semibold">
                  {subTitle}
                </Text>
              </>
            )}

            {description && (
              <>
                <Spacer size="16px" size1280="24px" />
                <Prose className={Styles.Description} html={description} />
              </>
            )}
          </div>

          {ctas && (
            <>
              <Spacer size="64px" size1280="0" />
              <CtaButtons contentfulContent={ctaGroup} location={location} />
            </>
          )}
        </div>
      </div>

      <div className={Styles.Cell}>{media && <MediaAsset content={media} location={location} />}</div>
    </div>
  )
}

try{ River.displayName ||= 'River' } catch {}